const sourceSystem = {
    "Priority": "Priority",
    "Zoho": "Crm",
    "Shopify": "Shopify"
}
// const sourceSystem = [
//     "Priority",
//     "Crm",
//     "Shopify"
// ]
export default sourceSystem;